import { Component, OnInit, Input, EventEmitter, Output, viewChild, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FeesEstimationAdminService } from '../../shared/services/fees-estimation-admin.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FeesEstimationAdminDto } from '../../shared/models/fees-estimation-admin.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { RegisterationAdminDecision, MeasurmentOfficerDecision, Languages, FormMode, ServiceStatus, ShipStatus, TugType, ShipSituations } from 'src/app/shared/models/enums.model';
import { FeesEstimationService } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation.service';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { EbookingRequestTugDTO } from 'src/app/front-user/services/e-booking/shared/models/ebooking-request-tug.model';
import { FeesEstimationDetailsComponent } from 'src/app/front-user/services/e-booking/fees-estimation-details/fees-estimation-details.component';
import { FeesEstimationRequestComponent } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation-request.component';

@Component({
  selector: 'app-measurement-officer-fees-new',
  templateUrl: './measurement-officer-fees-new.component.html',
  styleUrls: ['./measurement-officer-fees-new.component.css']
})
export class MeasurementOfficerFeesComponentNew implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  decision = MeasurmentOfficerDecision;
  decisionKeys = Object.keys(this.decision);
  reviewerdecision = RegisterationAdminDecision;
  reviewerdecisionKeys = Object.keys(this.reviewerdecision);
  reviewerdecisionValue: number;
  displayedLang: string;
  // measurementReviewerForm: FormGroup;
  public measurementOfficerForm: FormGroup;
  user: User = new User();
  showRequest = false;
  MeasurmentOffcierObject: FeesEstimationAdminDto = new FeesEstimationAdminDto();
  agentId: string;
  shipStatus = ShipStatus;
  shipSituations = ShipSituations;
  shipSituationsKeys = Object.keys(this.shipSituations);
  //public formMode: FormMode.Readonly;
  feesEstimationObj: FeesEstimate = new FeesEstimate();
  responseObj: ResponseObject = new ResponseObject();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @Input() public isShow: boolean = true;
  @ViewChild('feesEstimationRequest', { static: false }) feesEstimationRequest: FeesEstimationRequestComponent;
  public disableForm: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  historicalAdminSCNT: number;
  historicalAdminSCGT: number;  // Add this new property



  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private feesSrv: FeesEstimationAdminService,
    private feesEstimationService: FeesEstimationService, private translate: TranslateService,) {
    this.isShow = true;
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    // this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.reviewerdecisionKeys = this.reviewerdecisionKeys.slice(this.reviewerdecisionKeys.length / 2);
    this.shipSituationsKeys = this.shipSituationsKeys.slice(this.shipSituationsKeys.length / 2);
    this.user = this.globalSrv.user;

  }

  ngOnInit() {
    this.buildForm(null);

  }

  get f() {
    return this.measurementOfficerForm.controls;
  }

  buildForm(reviewerdecision) {
    this.measurementOfficerForm = this.formBuilder.group({
      ReviewerDecision: ['', [Validators.required]],
    });
    if (reviewerdecision == RegisterationAdminDecision.Approve) {
      this.measurementOfficerForm = this.formBuilder.group({
        ReviewerDecision: ['', [Validators.required]],
        shipSituation: ['', [Validators.required]],
        InsuranceValue: new FormControl('', [Validators.pattern(this.numberRegex)]),
        FeeValue: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
        // Decision: ['', Validators.required],
        Currency: new FormControl({ value: '', disabled: true }),
        MeasurementDescription: [''],
        escortTugs: this.formBuilder.array([]),
        AdminSCGT: new FormControl("", [Validators.pattern(this.numberRegex)]),
        AdminSCNT: new FormControl("", [Validators.required, Validators.pattern(this.numberRegex)]),
      });
    }

    if (reviewerdecision == RegisterationAdminDecision.MoreInformation) {
      this.measurementOfficerForm = this.formBuilder.group({
        ReviewerDecision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });

    }
  }

  changeDecision(value) {
    this.buildForm(value);
    this.measurementOfficerForm.patchValue({
      ReviewerDecision: value
    });

    this.reviewerdecisionValue = value;
    if (this.reviewerdecisionValue == RegisterationAdminDecision.Approve) {

      if (this.globalSrv.getLanguage() == Languages.Arabic) {

        this.measurementOfficerForm.patchValue({
          Currency: this.feesEstimationObj.Currency.NameAR,
        });
      }
      else {
        this.measurementOfficerForm.patchValue({
          Currency: this.feesEstimationObj.Currency.NameEN,
        });
      }

      // Handle historical AdminSCNT
      if (this.historicalAdminSCNT != null && this.feesEstimationObj.AdminSCNT == null) {
        this.measurementOfficerForm.patchValue({
          AdminSCNT: this.historicalAdminSCNT
        });
        // Trigger the calculation logic
        this.feesEstimationObj.AdminSCNT = this.historicalAdminSCNT;
        this.populateEscortTugs();
      } else if (this.feesEstimationObj.AdminSCNT != null) {
        this.measurementOfficerForm.patchValue({
          AdminSCNT: this.feesEstimationObj.AdminSCNT
        });
        if (this.requestStatus != ServiceStatus.PendingonMeasurementsDepartmentManagerApproval)
          this.populateEscortTugs();
      }

      // Handle historical AdminSCGT

      if (this.historicalAdminSCGT != null && this.feesEstimationObj.AdminSCGT == null) {
        this.measurementOfficerForm.patchValue({
          AdminSCGT: this.historicalAdminSCGT
        });
        this.feesEstimationObj.AdminSCGT = this.historicalAdminSCGT;

      } else if (this.feesEstimationObj.AdminSCGT != null) {
        this.measurementOfficerForm.patchValue({
          AdminSCGT: this.feesEstimationObj.AdminSCGT
        });
      }





      if (this.requestStatus == ServiceStatus.PendingonMeasurementsDepartmentManagerApproval) { // to patch existed fees data when changing option
        this.measurementOfficerForm.patchValue({
          ReviewerDecision: RegisterationAdminDecision.Approve,
          shipSituation: this.feesEstimationObj.ShipSituation,
          FeeValue: this.feesEstimationObj.FeeValue,
          InsuranceValue: this.feesEstimationObj.InsuranceValue,
          MeasurementDescription: this.feesEstimationObj.MeasurementDescription,
          AdminSCNT: this.feesEstimationObj.AdminSCNT,
          AdminSCGT: this.feesEstimationObj.AdminSCGT
        });

        const ebookingRequestTugs = this.feesEstimationObj.EbookingRequestTugs as EbookingRequestTugDTO[];
        ebookingRequestTugs.forEach(tug => {
          this.escortTugsArray.push(
            this.formBuilder.group({
              tugsNumber: new FormControl({ value: tug.TugsNo, disabled: false }),
              reason: new FormControl({ value: tug.Reason, disabled: false }),
              note: new FormControl({ value: tug.MeasurmentNote, disabled: false })
            })
          );
        });
      }

    }
    else if (this.reviewerdecisionValue == RegisterationAdminDecision.MoreInformation) {

      if (this.measurementOfficerForm.disabled) { //to doesn't patch moreinformation in add or edit mode
        this.measurementOfficerForm.patchValue({
          ReviewerDecision: RegisterationAdminDecision.MoreInformation,
          MoreInformation: this.responseObj.Data['MoreInformation']
        });
      }
    }
  }

  receiveHistoricalAdminSCNT(event) {
    if (event)
      this.historicalAdminSCNT = event;
  }

  // Add new method to receive historical AdminSCGT
  receiveHistoricalAdminSCGT(event) {
    if (event)
      this.historicalAdminSCGT = event;
  }


  getBaseRequest() {
    this.feesEstimationService.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {

          this.feesEstimationObj = this.responseObj.Data;
          this.requestStatus = this.feesEstimationObj.StatusId;
          this.agentId = this.feesEstimationObj.RequestorId;
          if (this.globalSrv.getLanguage() == Languages.Arabic) {

            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameAR,
            });
          }
          else {
            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameEN,
            });
          }
          // check if component open fron request history
          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
            //to view "more information" data in case Measurement officer require it from agent and penending agent update
            //or after agent update request and pending Measurement officer approval 
            if (this.responseObj.Data['MoreInformation'] && (this.requestStatus == ServiceStatus.PendingOnMeasurementsOfficerApproval || this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent)) {
              this.reviewerdecisionValue = RegisterationAdminDecision.MoreInformation;
              this.buildForm(this.reviewerdecisionValue);
              this.measurementOfficerForm.patchValue({
                ReviewerDecision: RegisterationAdminDecision.MoreInformation,
                MoreInformation: this.responseObj.Data['MoreInformation']
              });

            }
            else {
              this.reviewerdecisionValue = RegisterationAdminDecision.Approve;
              //this.buildForm(this.reviewerdecisionValue);
              this.changeDecision(this.reviewerdecisionValue);
              this.measurementOfficerForm.patchValue({
                ReviewerDecision: RegisterationAdminDecision.Approve,
                FeeValue: this.feesEstimationObj.FeeValue,
                InsuranceValue: this.feesEstimationObj.InsuranceValue,
                MeasurementDescription: this.feesEstimationObj.MeasurementDescription,
                shipSituation: this.feesEstimationObj.ShipSituation,
                AdminSCNT: this.feesEstimationObj.AdminSCNT,
                AdminSCGT: this.feesEstimationObj.AdminSCGT,
              });
            }
            this.measurementOfficerForm.disable();
            this.disableForm = true;
            this.measurementOfficerForm.controls.ReviewerDecision.disable();
            console.log(this.formMode);
            console.log(this.measurementOfficerForm.controls.ReviewerDecision.status);
          }

          else if (this.requestStatus == ServiceStatus.PendingOnMeasurementsOfficerApproval) {
            this.formMode = FormMode.Add;
            this.measurementOfficerForm.enable();
            // this.measurementOfficerForm.controls.Currency.disable();
          }
          else {
            // to hide submit button
            this.formMode = FormMode.Readonly;
            //************************ */
            if (this.requestStatus == ServiceStatus.PendingonMeasurementsDepartmentManagerApproval) {
              this.measurementOfficerForm.enable();
              //this.measurementOfficerForm.controls.Currency.disable();

            }
            else {
              this.measurementOfficerForm.disable();
            }
            this.reviewerdecisionValue = RegisterationAdminDecision.Approve;
            //this.buildForm(this.reviewerdecisionValue);
            this.changeDecision(this.reviewerdecisionValue);
            this.measurementOfficerForm.controls.Currency.disable();
            this.measurementOfficerForm.patchValue({
              ReviewerDecision: RegisterationAdminDecision.Approve,
              FeeValue: this.feesEstimationObj.FeeValue,
              InsuranceValue: this.feesEstimationObj.InsuranceValue,
              MeasurementDescription: this.feesEstimationObj.MeasurementDescription,
              shipSituation: this.feesEstimationObj.ShipSituation,
              AdminSCNT: this.feesEstimationObj.AdminSCNT,
              AdminSCGT: this.feesEstimationObj.AdminSCGT
            });
          }

        }

      }
    )
  }

  CaluclateAndPopulateTugBoats(event) {
    const adminScnt = event.target.value;
    this.feesEstimationObj.AdminSCNT = adminScnt;
    this.populateEscortTugs();
  }

  populateEscortTugs() {
    this.escortTugsArray.clear();
    const escortTugs = this.calculateEscortTugs(this.feesEstimationObj);
    escortTugs.forEach(tug => {
      this.escortTugsArray.push(
        this.formBuilder.group({
          tugsNumber: [tug.tugsNumber, [Validators.required, Validators.min(1)]],
          reason: [tug.reason],
          note: [tug.note]
        })
      );
    });
  }


  get escortTugsArray() {
    return this.measurementOfficerForm.get('escortTugs') as FormArray;
  }

  calculateEscortTugs(feesEstimationObj: FeesEstimate): { tugsNumber: number; reason: string; note: string }[] {
    const result: { tugsNumber: number; reason: string; note: string }[] = [];

    const { ShipTypeId, AdminSCNT, Width, SubmersibleAccess, IsGasShip, ShipStatus: shipStatus } = feesEstimationObj;

    // --- 1. CONTAINER ---
    if (ShipTypeId == 29) {
      if (AdminSCNT >= 170000) {
        result.push({
          tugsNumber: 2,
          reason: 'Container SCNT ≥ 170000',
          note: ''
        });
      }
    }

    // --- 2. LPG & LNG ---
    else if (ShipTypeId == 26 || ShipTypeId == 27) {
      if (shipStatus == ShipStatus.Loaded) {
        // Loaded
        if (AdminSCNT > 40000 && AdminSCNT <= 90000) {
          result.push({
            tugsNumber: 1,
            reason: 'LPG/LNG Loaded SCNT 40000–90000',
            note: ''
          });
        } else if (AdminSCNT > 90000) {
          result.push({
            tugsNumber: 2,
            reason: 'LPG/LNG Loaded SCNT > 90000',
            note: ''
          });
        }
      } else {
        // Ballast
        if (!IsGasShip) {
          // Not Gas Free
          if (AdminSCNT > 40000 && AdminSCNT <= 90000) {
            result.push({
              tugsNumber: 1,
              reason: 'LPG/LNG Ballast (Not Gas Free) SCNT 40000–90000',
              note: ''
            });
            result.push(...this.beamCheck(Width, 'LPG/LNG Ballast (Not Gas Free) Beam Check'));
          } else if (AdminSCNT > 90000) {
            result.push({
              tugsNumber: 2,
              reason: 'LPG/LNG Ballast (Not Gas Free) SCNT > 90000',
              note: ''
            });
            result.push(...this.beamCheck(Width, 'LPG/LNG Ballast (Not Gas Free) Beam Check'));
          }
        } else {
          // Gas Free
          result.push(...this.beamCheck(Width, 'LPG/LNG Gas Free Beam Check'));
        }
      }
    }

    // --- 3. OTHERS (Not Container or LPG/LNG) ---
    else {
      if (shipStatus == ShipStatus.Loaded) {
        // Loaded
        if (AdminSCNT >= 70000 && AdminSCNT <= 90000) {
          result.push({
            tugsNumber: 1,
            reason: 'Not Container or LPG/LNG Loaded SCNT 70000–90000',
            note: ''
          });
        } else if (AdminSCNT > 90000) {
          result.push({
            tugsNumber: 2,
            reason: 'Not Container or LPG/LNG Loaded SCNT > 90000',
            note: ''
          });
        } else if (AdminSCNT < 70000 && Number(SubmersibleAccess) > 47) {
          result.push({
            tugsNumber: 1,
            reason: 'Not Container or LPG/LNG Loaded SCNT < 70000 & Draught > 47 ft',
            note: ''
          });
        }
      } else {
        // Ballast
        if (AdminSCNT > 130000) {
          result.push({
            tugsNumber: 1,
            reason: 'Not Container or LPG/LNG Ballast SCNT > 130000',
            note: ''
          });
          result.push(...this.beamCheck(Width, 'Not Container or LPG/LNG Ballast Beam Check'));
        }
      }
    }

    return result;
  }

  beamCheck(beam: number, context: string): { tugsNumber: number; reason: string; note: string }[] {
    const res: { tugsNumber: number; reason: string; note: string }[] = [];

    if (beam > 218 && beam <= 233) {
      res.push({ tugsNumber: 1, reason: `${context} (Beam 218–233 ft)`, note: '' });
    } else if (beam > 233) {
      res.push({ tugsNumber: 2, reason: `${context} (Beam > 233 ft)`, note: '' });
    }

    return res;
  }

  addEscortTugRule() {
    this.escortTugsArray.push(
      this.formBuilder.group({
        tugsNumber: ["", [Validators.required, Validators.min(1)]],
        reason: [""],
        note: [""]
      })
    );
  }

  deleteEscortTugRule(index: number): void {
    this.escortTugsArray.removeAt(index);
  }

  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.measurementOfficerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.MeasurmentOffcierObject = this.measurementOfficerForm.value;
    this.MeasurmentOffcierObject.AdminEmail = this.user.UserName;
    this.MeasurmentOffcierObject.RequestId = this.baseRequestId;
    this.MeasurmentOffcierObject.Decision = this.reviewerdecisionValue;
    if (this.reviewerdecisionValue == RegisterationAdminDecision.Approve) {
      this.MeasurmentOffcierObject.EbookingRequestTugs = this.escortTugsArray.value.map(tug => ({
        tugType: TugType.EscortTug,
        tugsNo: tug.tugsNumber,
        reason: tug.reason,
        measurmentNote: tug.note,
        requestId: this.baseRequestId,
        assignedBy: this.user.UserName
      }));
    }


    this.feesSrv.fillMeasurmentFees(this.MeasurmentOffcierObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.measurementOfficerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
